/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { isArray } from 'lodash';

// Components
import MemberRoleEditor from 'ui/components/team/MemberRoleEditor.vue';
import MemberRoleEditorModal from 'ui/components/team/MemberRoleEditorModal.vue';
import RemoveMemberModal from 'ui/components/team/RemoveMemberModal.vue';
import SmartTable from 'shared/ui/components/tables/SmartTable.vue';

const __vue_script__ = {
    name: 'MembersList',

    components: { SmartTable },

    props: {
        event: {
            type: Object,
            required: true
        },

        user: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            readOnly: false,
            editor: MemberRoleEditor,
            excludeEmails: [],
            members: []
        };
    },

    created() {
        this.loadMembers();
        this.readOnly = !this.$services.user.hasPermission('access_modification_realms.add_event_team_member', {
            event_id: this.event._id || this.event.id
        });
    },

    methods: {
        /**
         * Loads the members list
         */
        async loadMembers() {
            try {
                const members = await this.$services.event.getTeamMembers(this.event.id || this.event._id);
                this.members = members.sort((a, b) => a.realname === b.realname ? 0 : a.realname > b.realname ? 1 : -1);
                this.excludeEmails = this.members.map(m => m.email);
            } catch (error) {
                console.error('[MembersList] Could not load the members list', error.message);
            }
        },

        /**
         * Shows the modal for adding a new team member
         */
        showAddMemberModal() {
            this.$modal.show(MemberRoleEditorModal, {
                event: this.event,
                list: this,
                excludeEmails: this.excludeEmails
            }, {
                classes: 'small',
                height: 'auto',
                reset: true
            });
        },

        /**
         * Prompts the user for member's removal
         *
         * @param {object|object[]} members
         */
        showDeleteModal(members) {
            this.$modal.show(RemoveMemberModal, {
                members: isArray(members) ? members : [members],
                list: this
            }, {
                classes: 'small',
                height: 'auto',
                reset: true
            });
        },

        /**
         * Removes the given users from the team members list
         *
         * @param {object[]} members the members to remove from the event
         */
        async removeTeamMembers(members) {
            try {
                for (const member of members) {
                    await this.$services.event.removeTeamMember(this.event._id || this.event.id, member.email);
                }

                const message = members.length === 1 ? 'single_removed' : 'all_removed';
                this.$notify({
                    group: 'flashes',
                    text: this.$t(`team_members.messages.${message}`).toString(),
                    type: 'success',
                    duration: 5000
                });

            } catch (error) {
                console.error('[MembersList] Could not delete team members', error.message);

            } finally {
                await this.loadMembers();
                this.$refs['table'].unselectAll();
            }
        },

        /**
         * Handler for when the role has been successfully changed
         */
        editComplete(data) {
            if (data.ok === true) {
                this.$notify({
                    group: 'flashes',
                    text: this.$t('team_members.messages.edited').toString(),
                    type: 'success',
                    duration: 5000
                });

                this.loadMembers();
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"members-list"},[_c('smart-table',{ref:"table",attrs:{"items":_vm.members,"editor":_vm.editor,"event":_vm.event,"total-items":_vm.members.length,"selectable":!_vm.readOnly,"exclude-emails":_vm.excludeEmails,"full-list-provided":true,"track-by":"name"},on:{"completed":_vm.editComplete},scopedSlots:_vm._u([(!_vm.readOnly)?{key:"actions",fn:function(ref){return [_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.showAddMemberModal()}}},[_vm._v(_vm._s(_vm.$t("team_members.actions.add")))])]}}:null,(!_vm.readOnly)?{key:"bulk-actions",fn:function(ref){
var selectedItems = ref.selectedItems;
return [_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.showDeleteModal(selectedItems)}}},[_vm._v(_vm._s(_vm.$tc('team_members.actions.remove_members', [selectedItems])))])]}}:null,{key:"headers",fn:function(ref){return [_c('th',{staticClass:"name"},[_vm._v(_vm._s(_vm.$t("team_members.list.headers.name")))]),_c('th',{staticClass:"email"},[_vm._v(_vm._s(_vm.$t("team_members.list.headers.email")))]),_c('th',{staticClass:"role"},[_vm._v(_vm._s(_vm.$t("team_members.list.headers.role")))]),(!_vm.readOnly)?_c('th',{staticClass:"row-actions"}):_vm._e()]}},{key:"row",fn:function(ref){
var member = ref.item;
var setPanelContent = ref.setPanelContent;
return [_c('td',{staticClass:"name",on:{"click":function($event){$event.stopPropagation();!_vm.readOnly && setPanelContent(member)}}},[_vm._v(_vm._s(member.realname))]),_c('td',{staticClass:"email"},[_vm._v(_vm._s(member.email))]),_c('td',{staticClass:"role"},[_vm._v(_vm._s(_vm.$t(("team_members.roles." + (member.role.role)))))]),(!_vm.readOnly)?_c('td',{staticClass:"row-actions"},[_c('div',{staticClass:"content-actions",on:{"click":function($event){$event.stopPropagation();}}},[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('team_members.actions.edit')),expression:"$t('team_members.actions.edit')"}],staticClass:"btn btn-icon single action edit",on:{"click":function($event){return setPanelContent(member)}}},[_c('i',{staticClass:"ic-edit"})]),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('general.remove')),expression:"$t('general.remove')"}],staticClass:"btn btn-icon btn-danger single action delete",on:{"click":function($event){return _vm.showDeleteModal(member)}}},[_c('i',{staticClass:"ic-trash"})])])]):_vm._e()]}}],null,true)})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MembersList.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__